
export default {
    loadData : async function() {
        let listData = require('../assets/json/itemsStatus.json');
        return listData;
    }
}